import React from 'react'
import { Card, Collapse } from 'antd'
import { PiLightning } from 'react-icons/pi'
import IntlMessages from '@vacationtracker/shared/components/utils/IntlMessages'
import { useIntl } from 'react-intl'
import ActionCenterCard from './ActionCenterCard'
import { IActionCenterInsight } from '@vacationtracker/shared/types/team-energy'
import { trackActionsExpanded } from '../services/teamEnergyTracking'

interface IActionCenterProps {
  totalInsights: number
  criticalCount: number
  insights: IActionCenterInsight[]
  defaultOpen?: boolean
}

const ActionCenter: React.FC<IActionCenterProps> = ({ totalInsights, criticalCount, insights, defaultOpen = true }) => {
  const { formatMessage } = useIntl()

  if (totalInsights === 0) {
    return null
  }

  const header = (
    <span className="te-action-center__header">
      <PiLightning size={14} className="te-action-center__icon" />
      <span className="te-action-center__title">
        <IntlMessages id="teamEnergy.actionCenter.title" />
      </span>
      <span className="te-action-center__count-badge">{formatMessage({ id: 'teamEnergy.actionCenter.insightsCount' }, { count: totalInsights })}</span>
      {criticalCount > 0 && <span className="te-action-center__critical-badge">{formatMessage({ id: 'teamEnergy.actionCenter.criticalCount' }, { count: criticalCount })}</span>}
    </span>
  )

  const handleCollapseChange = (activeKeys: string | string[]) => {
    const keys = Array.isArray(activeKeys) ? activeKeys : [activeKeys]
    if (keys.includes('action-center')) {
      trackActionsExpanded()
    }
  }

  return (
    <Card size="small" className="te-action-center">
      <Collapse
        ghost
        defaultActiveKey={defaultOpen ? ['action-center'] : []}
        onChange={handleCollapseChange}
        items={[
          {
            key: 'action-center',
            label: header,
            children: (
              <div className="te-action-center__cards">
                {insights.map((insight) => (
                  <ActionCenterCard key={insight.id} insight={insight} />
                ))}
              </div>
            ),
          },
        ]}
      />
    </Card>
  )
}

export default ActionCenter
